import { render } from "./MediaflowSourcesTip.vue?vue&type=template&id=76a64bd8"
import script from "./MediaflowSourcesTip.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowSourcesTip.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowSourcesTip.vue?vue&type=style&index=0&id=76a64bd8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowSourcesTip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76a64bd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76a64bd8', __exports__)) {
    api.reload('76a64bd8', __exports__)
  }
  
  module.hot.accept("./MediaflowSourcesTip.vue?vue&type=template&id=76a64bd8", () => {
    api.rerender('76a64bd8', render)
  })

}


export default __exports__